var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c("div", { staticClass: "bg-secondary-3 p-3 mt-3 rounded" }, [
    _c("div", { staticClass: "row px-3" }, [
      _c("div", { staticClass: "col-12 col-md-4" }, [
        _c("span", { staticClass: "font-weight-normal text-gray font-14" }, [
          _vm._v(" Tipo de Documento: ")
        ]),
        _c("p", { staticClass: "font-16" }, [
          _vm._v(_vm._s(_vm.document.documentTypeName))
        ])
      ]),
      _c("div", { staticClass: "col-12 col-md-7" }, [
        _c("span", { staticClass: "font-weight-normal text-gray font-14" }, [
          _vm._v(" Nombre de Documento: ")
        ]),
        _c("p", { staticClass: "font-16" }, [
          _vm._v(_vm._s(_vm.document.fileName))
        ])
      ]),
      _c(
        "div",
        { staticClass: "col-12 col-md-1 text-right" },
        [
          _c("action-button", {
            staticClass: "mr-2 mt-2",
            attrs: { i: "fas fa-file-download", variant: "success" },
            on: {
              click: () => _vm.$emit("on-download", _vm.document.documentId)
            }
          }),
          _vm.hasDeletePermission
            ? _c("action-button", {
                staticClass: "mr-2 mt-2",
                attrs: { i: "fas fa-times-circle", variant: "danger" },
                on: {
                  click: function($event) {
                    return _vm.$emit("on-remove", _vm.document.documentId)
                  }
                }
              })
            : _vm._e()
        ],
        1
      )
    ])
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }